import { XMLInterfaceObject } from "@goodgamestudios/core";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";
import { ShopVO } from "./ShopVO";

export class ItemsVO extends ShopVO {
    private itemLayerByCategory: any[] = [{ itemCategory: "backgrounds", layer: 0 },
    { itemCategory: "skin", layer: 1 },
    { itemCategory: "hair", layer: 4 },
    { itemCategory: "eyes", layer: 3 },
    { itemCategory: "nose", layer: 2 },
    { itemCategory: "mouth", layer: 5 },
    { itemCategory: "birthmark", layer: 6 },
    { itemCategory: "freckles", layer: 7 },
    { itemCategory: "cheeks", layer: 8 },
    { itemCategory: "underwearBottom", layer: 9 },
    { itemCategory: "underwearTop", layer: 10 },
    { itemCategory: "beards", layer: 11 },
    { itemCategory: "tattooHead", layer: 12 },
    { itemCategory: "tattooUpper", layer: 13 },
    { itemCategory: "tattooLower", layer: 14 },
    { itemCategory: "jewleryBottom", layer: 15 },
    { itemCategory: "shoes", layer: 16 },
    { itemCategory: "legs", layer: 17 },
    { itemCategory: "shirt", layer: 18 },
    { itemCategory: "tshirts", layer: 19 },
    { itemCategory: "poloshirts", layer: 20 },
    { itemCategory: "tie", layer: 21 },
    { itemCategory: "pullover", layer: 22 },
    { itemCategory: "scarf", layer: 23 },
    { itemCategory: "suit", layer: 24 },
    { itemCategory: "costume", layer: 25 },
    { itemCategory: "jacket", layer: 26 },
    { itemCategory: "jewleryTop", layer: 27 },
    { itemCategory: "glasses", layer: 28 },
    { itemCategory: "hats", layer: 29 },
    { itemCategory: "bags", layer: 30 },
    { itemCategory: "gimmicks", layer: 31 },
    { itemCategory: "pets", layer: 32 },
    { itemCategory: "vehicles", layer: 33 },
    { itemCategory: "partner", layer: 34 },
    { itemCategory: "children", layer: 35 }];

    private _currentColor: string;

    public colorTableId: number = 0;
    public sex: string;
    public level: number = 0;
    public hasHair: boolean = false;

    constructor() {
        CONSTRUCTOR_HACK;
        super();
    }

    public getVisClassName(): string {
        return this.itemCategory + "_" + this.id;
    }

    public get currentColor(): string {
        return this._currentColor;
    }
    public set currentColor(value: string) {
        this._currentColor = value;
    }
    public getItemLayer(): number {
        if (this.itemLayerByCategory != null) {
            for (let entryList of this.itemLayerByCategory) {
                var layerObject: any = entryList;
                if (layerObject === undefined) continue;
                if (layerObject.itemCategory == this.itemCategory)
                    return int(layerObject.layer);
            }
        }
        return 0;
    }
    public fillFromParamXML(wodElement: XMLInterfaceObject): void {
        super.fillFromParamXML(wodElement);
        this.sex = (wodElement['sex'] || '');
        this.level = parseInt((wodElement['level'] || ''));
        this.colorTableId = parseInt((wodElement['colorTable'] || ''));
        if (this.itemCategory == "costume")
            this.hasHair = parseInt((wodElement['hasHair'] || '')) == 1;
        else
            this.hasHair = false;
    }
}
classImplementsInterfaces(ItemsVO, "IInventoryVO");
